// Number formatting for Indonesian UI copy: dot thousands, comma decimals.
const integer = new Intl.NumberFormat("id-ID", { maximumFractionDigits: 0 });
const oneDecimal = new Intl.NumberFormat("id-ID", { maximumFractionDigits: 1 });

/** 1234 -> "1.234"; 12.5 -> "12,5" (at most one decimal). */
export function formatNumber(n: number): string {
  return Number.isInteger(n) ? integer.format(n) : oneDecimal.format(n);
}

/** A share of a total as a percent string, e.g. 0.714 -> "71,4%". */
export function formatPercent(part: number, total: number): string {
  if (total <= 0) return "0%";
  return `${oneDecimal.format((part / total) * 100)}%`;
}
